<template>
    <div>
        <select class="vue-select" :class="id" :multiple="!!multiple"></select>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import uuid4 from 'uuid4';
import {SharingService} from "../../../services/SharingService";

export default {
    props: {
      endpoint: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'ajax'
      },
      data: {
        type: Array,
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        results: [],
        query: null,
        val: null,
        id: null,
        selector: null,
        sharedResourceType: null,
      };
    },
    beforeMount() {
      this.id = uuid4();
      this.selector = '.' + this.id;
    },
    mounted() {
      const vm = this;

      const element = $(this.selector);
      if (this.type === 'ajax') {
        if (this.endpoint.includes('search/product')) {
          this.sharedResourceType = 'product';
        } else if (this.endpoint.includes('search/food')) {
          this.sharedResourceType = 'food';
        }
        element.select2({
              disabled: this.disabled,
              templateResult: function(state) {
                if (!state.externalId) {
                  return state.text
                }

                const owner = SharingService.getOwnerIfShared(
                    vm.configuration.sharedResources,
                    state.externalId,
                    vm.sharedResourceType
                )
                if (!owner) {
                  return state.text;
                }

                return $('<span data-toggle="tooltip" title="Udostępnione przez '
                    + owner
                    + '">'
                    + state.text
                    + '<i class="fa fa-fw fa-share-alt text-success" aria-hidden="true"></i></span>');
              },
              minimumInputLength: 3,
              placeholder: this.placeholder,
              width: '100%',
              language: {
                inputTooShort: function() {
                  return 'Proszę podać co najmniej trzy znaki.';
                },
                searching: function() {
                  return 'Trwa wyszukiwanie…';
                },
                loadingMore: function() {
                  return 'Trwa ładowanie…';
                },
              },
              ajax: {
                dataType: 'json',
                url: function() {
                  return vm.endpoint;
                },
                delay: 250,
                data: function(params) {
                  return {
                    q: params.term,
                    page: params.page || 1,
                  };
                },
                processResults: function(response, params) {
                  params.page = params.page || 1;
                  vm.results = vm.results.concat(response.data);

                  return {
                    results: response.data.map(item => {
                      const name = item.portions > 1 ? item.name + ' (' + item.portions + 'p.)': item.name;
                      return { text: name, id: item.id , externalId: item.externalId};
                    }),
                    pagination: {
                      more: (params.page * 10) < response.pagination.count,
                    },
                  };
                },
                cache: true,
              },
            }).on('change', function() {
          vm.val = $(this).val();
        });

      }
      if (this.type === 'array') {
        this.results = this.data;
        element.select2({
              disabled: this.disabled,
              width: '100%',
              data: this.data
            }).on('change', function() {
          vm.val = $(this).val();
        });
      }
      this.$emit('mount');
    },
    methods: {
      reset() {
        $(this.selector).val(null).trigger('change');
      },
      setValue(value) {
        $(this.selector).val(value);
        $(this.selector).trigger('change');
      }
    },
    computed: {
      ...mapGetters([
          'configuration',
      ])
    },
    watch: {
      val: function(value) {
        if (Array.isArray(value)) {
          this.$emit('item-selected', this.results.filter(p => value.includes(p.id)));
        } else {
          this.$emit('item-selected', this.results.find(p => {
            if (typeof p.id === 'number') {
              return p.id === Number(value);
            }
            return p.id === value
          }));
        }
      },
    },
    destroyed: function() {
      $(this.selector).off().select2('destroy');
    },
  }
  ;
</script>
